import { manageApi } from '@/api';
import { PlusIcon } from '@/components/icons';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button, ConfirmModal, InlineAlert } from '@/components/ui';
import { useTableActions } from '@/context/TablesContext';
import { ManageTable } from '@/features/manage/components/ManageTable';
import { TableFormModal } from '@/features/manage/components/TableFormModal';
import { TableManageRow } from '@/features/manage/components/TableManageRow';
import { useManagedList } from '@/features/manage/useManagedList';

const COLUMNS = [{ label: 'Name' }, { label: 'Type' }, { label: 'Rate / hr', align: 'right' as const }, { label: 'Order' }];

/** Admin: add, edit and delete the club's tables. Delete archives; past bookings and bills keep the table. */
export function ManageTablesPage() {
  const { refresh } = useTableActions();
  const list = useManagedList(manageApi.tables, refresh);
  const editing = list.editing;

  return (
    <>
      <PageHeader
        title="Manage tables"
        aside={
          <Button variant="primary" icon={<PlusIcon size={16} />} onClick={list.startCreate}>
            Add table
          </Button>
        }
      />

      {list.error && <InlineAlert message={list.error} onDismiss={list.dismissError} />}

      <ManageTable columns={COLUMNS} loading={list.loading} isEmpty={list.items.length === 0} emptyText="No tables yet. Add the club's first table.">
        {list.items.map((t) => (
          <TableManageRow key={t.id} table={t} onEdit={() => list.startEdit(t)} onDelete={() => list.startDelete(t)} />
        ))}
      </ManageTable>

      {editing && (
        <TableFormModal
          key={editing === 'new' ? 'new' : editing.id}
          table={editing === 'new' ? null : editing}
          busy={list.busy}
          error={list.modalError}
          onSave={list.save}
          onClose={list.close}
        />
      )}

      <ConfirmModal
        open={!!list.deleting}
        title="Delete table"
        message={<>Are you sure you want to delete <strong>{list.deleting?.name}</strong>?</>}
        confirmLabel="Delete"
        busyLabel="Deleting…"
        busy={list.busy}
        error={list.modalError}
        onConfirm={list.confirmDelete}
        onCancel={list.close}
      />
    </>
  );
}
